import { Button, Grid2, Tooltip, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { Loading } from '../../../UI'
import { Modal } from '../../../_EOS/Modal'
import { useModal } from '../../../../hooks/useModal'
import { ModalAsnComment } from './ModalAsnComment'

interface ModalAsnReceivedProps {
  asnId: number
  handleCloseModal: () => void
  handleSubmitAction: (
    asnId: number,
    comment?: string,
    isReserve?: boolean
  ) => void
  isLoading: boolean
}

export const ModalAsnReceived: React.FC<ModalAsnReceivedProps> = ({
  asnId,
  handleSubmitAction,
  isLoading,
  handleCloseModal
}) => {
  const commentModalState = useModal<{
    id: number
  }>('')

  const [comment, setComment] = useState<string>('')

  const requestReceivedAsn = () => {
    handleSubmitAction(asnId, comment.trim(), true)
    setComment('')
    commentModalState.closeModal()
  }

  if (isLoading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  }

  return (
    <Fragment>
      <Grid2 container spacing={2}>
        <Grid2 size={12} sx={{ textAlign: 'center' }}>
          <Typography variant='h6'>{`Seleccione Tipo de Recepción ASN N° ${asnId}`}</Typography>
        </Grid2>
        <Grid2 size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip
            title='ASN se podra recepcionar por posicionamiento habitual'
            placement='top-end'
          >
            <Button
              className='btn-upload'
              color='primary'
              variant='contained'
              component='span'
              onClick={() => {
                handleCloseModal()
                handleSubmitAction(asnId)
              }}
              disabled={isLoading}
            >
              Posicionamiento Habitual
            </Button>
          </Tooltip>
        </Grid2>
        <Grid2 size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip
            title='ASN se podra almacenar temporalmente en Ubicación de Reserva'
            placement='top-end'
          >
            <Button
              className='btn-upload'
              color='primary'
              variant='contained'
              component='span'
              onClick={() => {
                commentModalState.openModal(
                  'sm',
                  { id: asnId },
                  'Recepción a Reserva'
                )
              }}
              disabled={isLoading}
            >
              Almacenar En Reserva
            </Button>
          </Tooltip>
        </Grid2>
      </Grid2>

      <Modal
        onClose={commentModalState.closeModal}
        open={commentModalState.isOpen}
        maxWidth={commentModalState.size}
        title={commentModalState.title}
      >
        <ModalAsnComment
          handleCloseModal={commentModalState.closeModal}
          handleCloseParentModal={handleCloseModal}
          requestCommentAsn={requestReceivedAsn}
          setComment={setComment}
          comment={comment}
        />
      </Modal>
    </Fragment>
  )
}
